export default __webpack_public_path__ + "static/index-header-img-sm-060f0ec5a29367756e80ca7e929b256f.webp";